var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowSwitchHorizontal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-switch-horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72206 1.5312C4.98241 1.79155 4.98241 2.21366 4.72206 2.47401L3.61013 3.58594H14.0007C14.3688 3.58594 14.6673 3.88441 14.6673 4.2526C14.6673 4.62079 14.3688 4.91927 14.0007 4.91927H3.61013L4.72206 6.0312C4.98241 6.29155 4.98241 6.71366 4.72206 6.97401C4.46171 7.23436 4.0396 7.23436 3.77925 6.97401L1.52925 4.72401C1.2689 4.46366 1.2689 4.04155 1.52925 3.7812L3.77925 1.5312C4.0396 1.27085 4.46171 1.27085 4.72206 1.5312ZM11.2792 9.0312C11.5396 8.77085 11.9617 8.77085 12.2221 9.0312L14.4721 11.2812C14.7324 11.5415 14.7324 11.9637 14.4721 12.224L12.2221 14.474C11.9617 14.7344 11.5396 14.7344 11.2792 14.474C11.0189 14.2137 11.0189 13.7915 11.2792 13.5312L12.3912 12.4193H2.00065C1.63246 12.4193 1.33398 12.1208 1.33398 11.7526C1.33398 11.3844 1.63246 11.0859 2.00065 11.0859H12.3912L11.2792 9.97401C11.0189 9.71366 11.0189 9.29155 11.2792 9.0312Z",
    fill: "#4A5467"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowSwitchHorizontal);
export default __webpack_public_path__ + "static/media/ic-arrow-switch-horizontal.93e0fe3ba5340b4ba5bc5c2ef14b1781.svg";
export { ForwardRef as ReactComponent };